import { Badge } from "@/components/ui/badge";
import { moraDe } from "@/components/cobro/logica";

export interface BadgeMoraProps {
  /** `estado_mora` tal como viene del backend. Desconocido o ausente = "Al día". */
  estado: string | null | undefined;
  /** "+30 días" en vez de "Debe hace +30 días": filas angostas y cintas. */
  corto?: boolean;
  className?: string;
}

/**
 * El unico badge de mora. AL_DIA y SIN_DEUDA en `secondary`, MORA_30/60 en
 * `warning`, MORA_90 en `destructive`: la cobranza decide a quien llamar
 * mirando esto, y el mismo cliente tiene que verse igual en Clientes, en
 * Cuentas corrientes, en el cobro y en el ticket.
 *
 * Es un chip de ESTADO: va al lado del importe, nunca le cambia el color.
 */
export function BadgeMora({ estado, corto = false, className }: BadgeMoraProps): JSX.Element {
  const mora = moraDe(estado);
  return (
    <Badge variant={mora.variante} title={corto ? mora.texto : undefined} className={className}>
      {corto ? mora.corto : mora.texto}
    </Badge>
  );
}
